import { SET_CHECKOUT_SHIPPING_ISCOMPLETE, SHOW_GLOBAL_ERROR, SET_GLOBAL_ISB3USER, SET_GLOBAL_ISPENDING, SET_CHECKOUT_SETTINGS } from '../actionTypes'
import { detectB3User } from '../../utils/util'

const defaultState = {
  error: undefined,
  isB3User: detectB3User(),
  isPending: true,
  checkoutSettings: {},
  checkoutShippingIsComplete: true,
}

export default (state = defaultState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case SHOW_GLOBAL_ERROR: return { ...state, error: action.payload }
    case SET_GLOBAL_ISB3USER: return { ...state, isB3User: action.payload }
    case SET_GLOBAL_ISPENDING: return { ...state, isPending: action.payload }
    case SET_CHECKOUT_SETTINGS: return { ...state, checkoutSettings: action.payload }
    case SET_CHECKOUT_SHIPPING_ISCOMPLETE: return { ...state, checkoutShippingIsComplete: action.payload }
    default: return state
  }
}
